import React, { useState } from 'react'

import {
  DateTimeRange,
  Fieldset,
  HintToggleButton,
  InputRadio,
  Legend,
  SearchButton,
  Select,
} from '@paytrace/pt-skel/Component'
import { getSubmittedData } from '@paytrace/pt-skel/Helper'
import { useMountUnmount } from '@paytrace/pt-skel/Hooks'
import PubSub from '@paytrace/pt-skel/Event/PubSub'
import Event from '../Event'

interface Props { }

const self = Symbol('ViewBatchReports')

export function ViewBatchReports (props: Props) {
  useMountUnmount(() => {
    PubSub.sub(self, Event.SEARCH_TRANSACTIONS_RESPONSE, (json) => {
      // TODO: handle the response
    })

    return () => {
      PubSub.unsub(self)
    }
  })

  const submit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    e.stopPropagation()

    PubSub.pub('VALIDATION_ERROR::clear')

    // TODO: properly map to the request
    const formData = getSubmittedData(e)
    PubSub.pub(
      Event.SEARCH_TRANSACTIONS_REQUEST,
      { ...formData }
    )

    return false
  }

  return (
    <>
      <div className='float-right'>
        <HintToggleButton />
        <a className='help-link' href="https://paytrace.atlassian.net/wiki/spaces/HD/pages/2025914776/View+Batch+Reports+-+Virtual+Terminal">Help</a>
      </div>
      <h1>View Batch Reports</h1>
      <hr className='clear' />

      <SearchForm onSubmit={submit} />
    </>
  )
}

function SearchForm (props: { onSubmit: (e: React.FormEvent<HTMLFormElement>) => any }) {
  const [searchType, setSearchType] = useState<string>('date')

  const searchUpdate = (e : any) => {
    const value = e.target.value
    setSearchType(value)
  }

  const getForm = () => {
    return ('date' === searchType) ? <DateTimeRange /> : <BatchSearchForm />
  }

  return (
    <Fieldset>
      <Legend title='Search' />

      <form onSubmit={props.onSubmit}>
        <InputRadio
          name='criteria'
          label='Search By'
          items={[{
            label: 'Date',
            value: 'date',
          }, {
            label: 'Batch',
            value: 'batch',
          }]}
          onChange={searchUpdate}
          defaultValue='date'
        />

        {getForm()}

        <SearchButton />
      </form>
    </Fieldset>
  )
}

function BatchSearchForm (props: {}) {
  return (
    <Select
      label='Batch Number'
      options={[{
        name: '12345 -- 5/18/2022 1:23:45 PM',
        val: '12345',
      }]}
      hintText="Please select the specific batch whose details you want to view."
    />
  )
}

export default ViewBatchReports
